import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import UserHandler from "js/utilities/user-handler";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import { ZOOM_ICON } from "js/config.jsx";


// BASH/CURL code Examples
import TEST_CONNECTION_CURL from "resources/code/restsdk-v2/bash/test-connection.bash.tpl";
import SESSION_TOKEN_CURL from "resources/code/restsdk-v2/bash/session-token.bash.tpl";
import ENROLLMENT_POST_CURL from "resources/code/restsdk-v2/bash/enrollment-post.bash.tpl";
import ENROLLMENT_GET_FACEMAP_CURL from "resources/code/restsdk-v2/bash/enrollment-get-facemap.bash.tpl";
import ENROLLMENT_DELETE_CURL from "resources/code/restsdk-v2/bash/enrollment-delete.bash.tpl";
import FACEMAP_POST_CURL from "resources/code/restsdk-v2/bash/facemap-post.bash.tpl";
import LIVENESS_CURL from "resources/code/restsdk-v2/bash/liveness.bash.tpl";
import COMPARE_CURL from "resources/code/restsdk-v2/bash/compare.bash.tpl";
import SEARCH_CURL from "resources/code/restsdk-v2/bash/search.bash.tpl";
import ID_CHECK_CURL from "resources/code/restsdk-v2/bash/id-check.bash.tpl";
import AGE_CHECK_CURL from "resources/code/restsdk-v2/bash/age-check.bash.tpl";
import ESTIMATE_AGE_CURL from "resources/code/restsdk-v2/bash/estimate-age.bash.tpl";

// Node Code Examples
import TEST_CONNECTION_NODEJS from "resources/code/restsdk-v2/nodejs/test-connection.js.tpl";
import SESSION_TOKEN_NODEJS from "resources/code/restsdk-v2/nodejs/session-token.js.tpl";
import ENROLLMENT_POST_NODEJS from "resources/code/restsdk-v2/nodejs/enrollment-post.js.tpl";
import ENROLLMENT_GET_FACEMAP_NODEJS from "resources/code/restsdk-v2/nodejs/enrollment-get-facemap.js.tpl";
import ENROLLMENT_DELETE_NODEJS from "resources/code/restsdk-v2/nodejs/enrollment-delete.js.tpl";
import FACEMAP_POST_NODEJS from "resources/code/restsdk-v2/nodejs/facemap-post.js.tpl";
import LIVENESS_NODEJS from "resources/code/restsdk-v2/nodejs/liveness.js.tpl";
import COMPARE_NODEJS from "resources/code/restsdk-v2/nodejs/compare.js.tpl";
import SEARCH_NODEJS from "resources/code/restsdk-v2/nodejs/search.js.tpl";
import ID_CHECK_NODEJS from "resources/code/restsdk-v2/nodejs/id-check.js.tpl";
import AGE_CHECK_NODEJS from "resources/code/restsdk-v2/nodejs/age-check.js.tpl";
import ESTIMATE_AGE_NODEJS from "resources/code/restsdk-v2/nodejs/estimate-age.js.tpl";

// Success Response Examples
import TEST_CONNECTION_RESPONSE_SUCCESS_JSON from "resources/code/restsdk-v2/response/success/test-connection.json.tpl";
import SESSION_TOKEN_RESPONSE_SUCCESS_JSON from "resources/code/restsdk-v2/response/success/session-token.json.tpl";
import ENROLLMENT_POST_RESPONSE_SUCCESS_JSON from "resources/code/restsdk-v2/response/success/enrollment-post.json.tpl";
import ENROLLMENT_GET_FACEMAP_RESPONSE_SUCCESS_JSON from "resources/code/restsdk-v2/response/success/enrollment-get-facemap.json.tpl";
import ENROLLMENT_DELETE_RESPONSE_SUCCESS_JSON from "resources/code/restsdk-v2/response/success/enrollment-delete.json.tpl";
import FACEMAP_POST_RESPONSE_SUCCESS_JSON from "resources/code/restsdk-v2/response/success/facemap-post.json.tpl";
import LIVENESS_RESPONSE_SUCCESS_JSON from "resources/code/restsdk-v2/response/success/liveness.json.tpl";
import COMPARE_RESPONSE_SUCCESS_JSON from "resources/code/restsdk-v2/response/success/compare.json.tpl";
import SEARCH_RESPONSE_SUCCESS_JSON from "resources/code/restsdk-v2/response/success/search.json.tpl";
import ID_CHECK_RESPONSE_SUCCESS_JSON from "resources/code/restsdk-v2/response/success/id-check.json.tpl";
import AGE_CHECK_RESPONSE_SUCCESS_JSON from "resources/code/restsdk-v2/response/success/age-check.json.tpl";
import ESTIMATE_AGE_RESPONSE_SUCCESS_JSON from "resources/code/restsdk-v2/response/success/estimate-age.json.tpl";

// Failure Response Examples
import ENROLLMENT_POST_RESPONSE_FAILURE_JSON from "resources/code/restsdk-v2/response/failure/enrollment-post.json.tpl";
import ENROLLMENT_GET_FACEMAP_RESPONSE_FAILURE_JSON from "resources/code/restsdk-v2/response/failure/enrollment-get-facemap.json.tpl";
import FACEMAP_POST_RESPONSE_FAILURE_JSON from "resources/code/restsdk-v2/response/failure/facemap-post.json.tpl";
import LIVENESS_RESPONSE_FAILURE_JSON from "resources/code/restsdk-v2/response/failure/liveness.json.tpl";
import COMPARE_RESPONSE_FAILURE_JSON from "resources/code/restsdk-v2/response/failure/compare.json.tpl";
import SEARCH_RESPONSE_FAILURE_JSON from "resources/code/restsdk-v2/response/failure/search.json.tpl";
import ID_CHECK_RESPONSE_FAILURE_JSON from "resources/code/restsdk-v2/response/failure/id-check.json.tpl";
import AGE_CHECK_RESPONSE_FAILURE_JSON from "resources/code/restsdk-v2/response/failure/age-check.json.tpl";
import ESTIMATE_AGE_RESPONSE_FAILURE_JSON from "resources/code/restsdk-v2/response/failure/estimate-age.json.tpl";

import SDKSidebar from "js/utilities/sdk-sidebar"

export default React.createClass({
  displayName: "webservice-guide",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var data  = [{name: "Introduction"},
                 {name: "Basic Usage"},
                 {name: "Test Your Connection"},
                 {name: "Security"},
                 {name: "Enrollment CRUD"},
                 {name: "Creating 2D Single Image FaceMaps"},
                 {name: "Liveness Detection"},
                 {name: "3D Face Matching"},
                 {name: "Face Search"},
                 {name: "ID Check"},
                 {name: "Age Check"},
                 {name: "Estimate Age"},
        ];

    var scrollToElement = initDeepLinkData(this.props);

    return {
            data: data,
            navMenuParent: null,
            navMenu: null,
            scrollToElement: scrollToElement
          };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    const appToken = "INSERT_APP_TOKEN_HERE";
    const serverToken = "INSERT_SERVER_TOKEN_HERE";

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container webservice-documentation">

              <section>
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="zoom-server-rest-api">Custom REST Sample Code API</h2>
                </div>
                <p>The REST Sample Code package creates REST endpoints that allow the Sample Apps to function the same as if they are pointed at the FaceTec Testing API.  In production, these endpoints should be called via internal server-to-server calls inside your private network.  Certain non-core request/responses properties in the REST Sample Code may differ from the FaceTec Testing API requests and responses for the FaceTec Testing API.  Please look at the REST Sample Code source for a definitive look at the request/response behavior.</p>
                <hr/>
              </section>

              <section>
                <h3 id="basic-usage">Basic Usage</h3>
                <h4 id="basic-usage-url">URL</h4>
                <p>All requests should be made to the API at <code>https://your.internal.zoomserver.instance.url</code>.
                    All available API endpoints listed below should be appended to this base url, for example the <code>/status</code> endpoint can be reached at <code>https://your.internal.zoomserver.instance.url/status</code>.</p>

                <h4 id="basic-usage-accepted-request-types">Accepted Request Types</h4>
                <p>POST requests are accepted with the following content-types:</p>
                <ul>
                    <li><p><code>application/json</code></p></li>
                </ul>

                <h4 id="basic-usage-accepted-request-types">X-User-Agent Header</h4>
                <p>All requests should include the <code>X-User-Agent</code> header. Valid values for this header can be generating by calling the <code>createZoomAPIUserAgentString</code> function on device, and include important information for the Server Dashboard to display correct values like Device Model and FaceTec Version.</p>
                <p></p>
              </section>



              <section>
                <h3 id="test-your-connection">Test your connection</h3>
                <p className="section-endpoint"><code>GET /status</code></p>

                <p><strong>Sample Request:</strong></p>
                <div className="code-container">
                  <CodeBlocks curl={TEST_CONNECTION_CURL({appToken})} node={TEST_CONNECTION_NODEJS({appToken})} />
                </div>

                <p><strong>Sample Response:</strong></p>
                <div className="code-container">
                    <CodeBlocks success={TEST_CONNECTION_RESPONSE_SUCCESS_JSON()} />
                </div>
                <p></p>
              </section>

              <section>
                <h3 id="test-your-connection">Session Token</h3>
                <p className="section-endpoint"><code>GET /session-token</code></p>

                <p>Generates an encrypted, signed piece of data called a Session Token, that gets taken in as the input to the device-side Session launch code. Please see the <Link to="/session-tokens">Session Tokens</Link> Guide for more information.</p>

                <p><strong>Sample Request:</strong></p>
                <div className="code-container">
                  <CodeBlocks curl={SESSION_TOKEN_CURL({appToken})} node={SESSION_TOKEN_NODEJS({appToken})} />
                </div>

                <p><strong>Sample Response:</strong></p>
                <div className="code-container">
                    <CodeBlocks success={SESSION_TOKEN_RESPONSE_SUCCESS_JSON()} />
                </div>
                <p></p>
              </section>


              <section>
                <h3 id="liveness-detection">Liveness Detection</h3>
                <p className="section-endpoint"><code>POST /liveness</code></p>

                <p><strong>Description:</strong></p>
                <p>Performs a Liveness Check on a <code>FaceMap</code>.</p>

                <p>FaceTec performs iBeta/NIST/ISO Certified Liveness Detection on every FaceTec 3D FaceMap that is processed by the FaceTec Server SDK.  A single Liveness Status is given for each Liveness Check, and is also reported back for each Authentication.</p>
                <p>Liveness Status are not reported and/or are not valid for:</p>
                <ul>
                  <li><p>2D Single Image FaceMaps -- 2D Single Image do not contain enough data to make a strong Liveness determination.</p></li>
                  <li><p>1:N Search -- 1:N Search is optimized for matching only.</p></li>
                </ul>

                <p><strong>Required Parameters:</strong></p>
                <ul>
                    <li><p><code>faceMap</code></p></li>
                    <li><p><code>auditTrailImage</code>: Captured image from the Session and provided back to the developer for security and auditing purposes.</p></li>
                    <li><p><code>lowQualityAuditTrailImage</code>: Captured low quality image from the Session and provided back to the developer for security and auditing purposes.</p></li>
                </ul>

                <p><strong>Sample Request:</strong></p>
                <div className="code-container">
                    <CodeBlocks  curl={LIVENESS_CURL({appToken})} node={LIVENESS_NODEJS({appToken})}  />
                </div>

                <p><strong>Response Data:</strong></p>
                <ul>
                  <li><p><code>glasses</code>: true/false. User of the captured session to be wearing glasses or not. true = User of the captured session was evaluated to be wearing glasses. false = User of the captured session was evaluated to not be wearing glasses.</p></li>
                  <li><p><code>sessionTokenStatus</code>: 0/1/2/3/4. 0 = Not Applicable, 1 = Valid, 2 = Expired, 3 = Not Provided, 4 = Invalid.</p></li>
                  <li><p><code>faceMapType</code>: 0/1/2. 0 = 3D FaceMap, 1 = 2D FaceMap, 2 = Unknown.</p></li>
                  <li><p><code>livenessStatus</code>: 0/1/2. 0 = passed, 1 = undetermined, 2 = undetermined. The FaceTec 3D FaceMap came from a session where there was a live human being if and only if the livenessStatus is 0.</p></li>
                  <li><p><code>auditTrailVerificationCheck</code>: 0/1. FaceTec will determine whether the Audit Trail Image came from the same session as the FaceMap or not. 0 = same session, 1 = not same session.</p></li>
                  <li><p><code>isLowQuality</code>: true/false. FaceTec evaluates session data for face pose, lighting, and many other indicators to assess the quality of the overall capture, this boolean indicates whether FaceTec evaluated the image(s) to be of poor quality. true = Evaluated as low quality. false = Not evaluated as low quality.</p></li>
                  <li><p><code>isReplayFaceMap</code>: true/false. Indication of whether a FaceMap was seen by the system already and thus is a replay. true = the FaceMap was a replay. false = the FaceMap was not a replay. </p></li>
                  <li><p><code>auditTrailMatchCheck</code>: 0/1. FaceTec Custom Server runs a match of the Audit Trail Image to the Session to help determine if that the person in the Audit Trail Image matches the person from the FaceMap. 0 = The Audit Trail Image matches the FaceMap. 1 = The Audit Trail Image does not match the FaceMap.</p></li>
                </ul>

                <p><strong>Sample Responses:</strong></p>
                <div className="code-container">
                    <CodeBlocks success={LIVENESS_RESPONSE_SUCCESS_JSON()} failure={LIVENESS_RESPONSE_FAILURE_JSON()} />
                </div>
                <p></p>
              </section>


              <section>
                  <h3 id="enrollment-crud">Enrollment CRUD</h3>

                  <h4 id="creating-an-enrollment">Creating an Enrollment</h4>
                  <p className="section-endpoint"><code>POST /enrollment</code></p>

                  <p><strong>Description:</strong></p>
                  <p>Performs a Liveness Check to Enroll a <code>FaceMap</code>. Enrollment only occurs if the Liveness Check succeeds.</p>

                  <p><strong>Required Parameters:</strong></p>
                  <ul>
                      <li><p><code>enrollmentIdentifier</code>: A unique string to represent this enrollment - user identity.</p></li>
                      <li><p><code>faceMap</code></p></li>
                      <li><p><code>auditTrailImage</code>: Captured image from the Session and provided back to the developer for security and auditing purposes.</p></li>
                      <li><p><code>lowQualityAuditTrailImage</code>: Captured low quality image from the Session and provided back to the developer for security and auditing purposes.</p></li>
                  </ul>

                  <p><strong>Sample Request:</strong></p>
                  <div className="code-container">
                      <CodeBlocks curl={ENROLLMENT_POST_CURL({appToken})} node={ENROLLMENT_POST_NODEJS({appToken})} />
                  </div>

                  <p><strong>Response Data:</strong></p>
                  <ul>
                    <li><p><code>glasses</code>: true/false. User of the captured session to be wearing glasses or not. true = User of the captured session was evaluated to be wearing glasses. false = User of the captured session was evaluated to not be wearing glasses.</p></li>
                    <li><p><code>sessionTokenStatus</code>: 0/1/2/3/4. 0 = Not Applicable, 1 = Valid, 2 = Expired, 3 = Not Provided, 4 = Invalid.</p></li>
                    <li><p><code>faceMapType</code>: 0/1/2. 0 = 3D FaceMap, 1 = 2D FaceMap, 2 = Unknown.</p></li>
                    <li><p><code>createdDate</code>: enrollment creation datetime.</p></li>
                    <li><p><code>livenessStatus</code>: 0/1/2. 0 = passed, 1 = undetermined, 2 = undetermined. </p></li>
                    <li><p><code>auditTrailVerificationCheck</code>: 0/1. FaceTec will determine whether the Audit Trail Image came from the same session as the FaceMap or not. 0 = same session, 1 = not same session.</p></li>
                    <li><p><code>isEnrolled</code>: true/false. true = Enrollment Identifier is enrolled. false = Enrollment Identifier is not enrolled. </p></li>
                    <li><p><code>isLowQuality</code>: true/false. FaceTec evaluates session data for face pose, lighting, and many other indicators to assess the quality of the overall capture, this boolean indicates whether FaceTec evaluated the image(s) to be of poor quality. true = Evaluated as low quality. false = Not evaluated as low quality.</p></li>
                    <li><p><code>auditTrailMatchCheck</code>: 0/1. FaceTec Custom Server runs a match of the Audit Trail Image to the Session to help determine if that the person in the Audit Trail Image matches the person from the FaceMap. 0 = The Audit Trail Image matches the FaceMap. 1 = The Audit Trail Image does not match the FaceMap.</p></li>
                    <li><p><code>isReplayFaceMap</code>: true/false. Indication of whether a FaceMap was seen by the system already and thus is a replay. true = the FaceMap was a replay. false = the FaceMap was not a replay. </p></li>
                  </ul>

                  <p><strong>Sample Response:</strong></p>
                  <div className="code-container">
                      <CodeBlocks success={ENROLLMENT_POST_RESPONSE_SUCCESS_JSON()} failure={ENROLLMENT_POST_RESPONSE_FAILURE_JSON()} />
                  </div>

                  <blockquote>
                      <p><strong>Note</strong>: FaceTec will not enroll any FaceMap that doesn&apos;t pass Liveness. This is special behavior of our REST API that can easily be changed if you implement your own. This behavior was chosen by FaceTec to guarantee that any FaceMap that is enrolled meets our standards of a high quality session which will benefit authentication and continuous learning.</p>
                  </blockquote>

                  <h4 id="reading-an-enrollment">Reading an Enrollment</h4>
                  <p className="section-endpoint"><code>GET /enrollment/:enrollmentIdentifier</code></p>
                  <p><strong>Required Parameters:</strong></p>
                  <ul>
                      <li><p><code>enrollmentIdentifier</code>: A unique string to represent this enrollment - user identity.</p></li>
                  </ul>
                  <p><strong>Optional Parameters:</strong></p>
                  <ul>
                      <li><p><code>return=faceMap,auditTrailImage</code> <strong>or</strong> <code>return=faceMap</code> <strong>or</strong> <code>return=auditTrailImage</code>: Instructs the response to include the enrolled <code>faceMap</code>, <code>faceMapType</code> and/or <code>auditTrailImage</code>. If you are only checking to make sure an enrollment exists, do not pass this parameter.</p></li>
                  </ul>

                  <p><strong>Sample Request:</strong></p>
                  <div className="code-container">
                      <CodeBlocks curl={ENROLLMENT_GET_FACEMAP_CURL({appToken})} node={ENROLLMENT_GET_FACEMAP_NODEJS({appToken})} />
                  </div>

                  <p><strong>Response Data:</strong></p>
                  <ul>
                    <li><p><code>enrollmentIdentifier</code>: enrollmentIdentifier value which was passed in request parameter.</p></li>
                    <li><p><code>glasses</code>: true/false. User of the captured session to be wearing glasses or not. true = User of the captured session was evaluated to be wearing glasses. false = User of the captured session was evaluated to not be wearing glasses.</p></li>
                    <li><p><code>sessionTokenStatus</code>: 0/1/2/3/4. 0 = Not Applicable, 1 = Valid, 2 = Expired, 3 = Not Provided, 4 = Invalid.</p></li>
                    <li><p><code>faceMapType</code>: 0/1/2. 0 = 3D FaceMap, 1 = 2D FaceMap, 2 = Unknown</p></li>
                    <li><p><code>livenessStatus</code>: 0/1/2. 0 = passed, 1 = undetermined, 2 = undetermined. </p></li>
                    <li><p><code>isLowQuality</code>: true/false. FaceTec evaluates session data for face pose, lighting, and many other indicators to assess the quality of the overall capture, this boolean indicates whether FaceTec evaluated the image(s) to be of poor quality. true = Evaluated as low quality. false = Not evaluated as low quality.</p></li>
                  </ul>

                  <p><strong>Sample Response:</strong></p>
                  <div className="code-container">
                      <CodeBlocks success={ENROLLMENT_GET_FACEMAP_RESPONSE_SUCCESS_JSON()} failure={ENROLLMENT_GET_FACEMAP_RESPONSE_FAILURE_JSON()} />
                  </div>

                  <h4 id="deleting-an-enrollment">Deleting an Enrollment</h4>
                  <p className="section-endpoint"><code>DELETE /enrollment/:enrollmentIdentifier</code></p>

                  <p><strong>Sample Request:</strong></p>
                  <div className="code-container">
                      <CodeBlocks curl={ENROLLMENT_DELETE_CURL({appToken})} node={ENROLLMENT_DELETE_NODEJS({appToken})} />
                  </div>

                  <p><strong>Sample Response:</strong></p>
                  <div className="code-container">
                      <CodeBlocks success={ENROLLMENT_DELETE_RESPONSE_SUCCESS_JSON()} />
                  </div>
                  <p></p>
              </section>

              <section>
                <h3 id="3d-face-matching">Face Matching</h3>
                <p className="section-endpoint"><code>POST /match-3d-3d</code>, <code>POST /match-3d-2d</code>, <code>POST /match-2d-2d</code></p>

                  <p><strong>Description:</strong></p>
                  <p>Perform matching of a single <code>source</code> against single <code>target</code>. For Match 3D 3D, a Liveness Check is ran on the target FaceMap, and Liveness was already ran on the previously created Enrollment.</p>

                  <p><strong>Required Parameters:</strong></p>
                  <ul>
                      <li><code>source</code>: A source object to match against.
                          <ul>
                              <li><p>Must have one of two properties:<br /><code>enrollmentIdentifier</code> <strong>or</strong> <code>faceMap</code></p></li>
                          </ul>
                      </li>
                      <li><code>target</code>: A target object to compare the source against.
                          <ul>
                             <li><p>Must have any of these properties:<br /><code>enrollmentIdentifier</code> <strong>or</strong> <code>faceMap</code><strong>or</strong> <code>image</code></p></li>
                          </ul>
                      </li>
                      <li><p><code>auditTrailImage</code>: Captured image from the Session and provided back to the developer for security and auditing purposes.</p></li>
                      <li><p><code>lowQualityAuditTrailImage</code>: Captured low quality image from the Session and provided back to the developer for security and auditing purposes.</p></li>
                  </ul>

                  <blockquote>
                      <p><strong>Important</strong>: The origin of the FaceMaps used for <code>source</code> and <code>target</code> are important when calling matching. The <code>source</code> FaceMap should be an enrollment FaceMap, which is a FaceMap that is being used and updated by continuous learning since this is the FaceMap that continues to get built on as successful match happen. The <code>target</code> FaceMap should be an authentication FaceMap, which is a FaceMap that has been collected to match against the enrollment FaceMap.</p>
                      <p><strong>Note</strong>: If Single Image 2D FaceMaps are used, continuous learning FaceMaps are never returned, the Liveness status for that FaceMap will be ZoomLivenessUnproven for that Single Image FaceMap.</p>
                  </blockquote>

                  <p><strong>Sample Request:</strong></p>
                  <div className="code-container">
                      <CodeBlocks curl={COMPARE_CURL({appToken})} node={COMPARE_NODEJS({appToken})} />
                  </div>

                 <p><strong>Response Data:</strong></p>
                 <ul>
                     <li><p><code>matchLevel</code>: FaceTec is capable of matching at FAR ranges of up to 1 in 4,200,000.  Please see <Link to="/matching-guide">Matching Guide</Link> for more information on interpreting FaceTec Match Levels.</p></li>
                     <li><p><code>sourceFaceMap</code>: Detail about sourceFaceMap.</p></li>
                     <li><p><code>targetFaceMap</code>: Detail about targetFaceMap.</p></li>
                     <li><p><code>glasses</code>: true/false. User of the captured session to be wearing glasses or not. true = User of the captured session was evaluated to be wearing glasses. false = User of the captured session was evaluated to not be wearing glasses.</p></li>
                     <li><p><code>sessionTokenStatus</code>: 0/1/2/3/4. 0 = Not Applicable, 1 = Valid, 2 = Expired, 3 = Not Provided, 4 = Invalid.</p></li>
                     <li><p><code>faceMapType</code>: 0/1/2. 0 = 3D FaceMap, 1 = 2D FaceMap, 2 = Unknown.</p></li>
                     <li><p><code>livenessStatus</code>: 0/1/2. 0 = passed, 1 = undetermined, 2 = undetermined. The FaceTec 3D FaceMap came from a session where there was a live human being if and only if the livenessStatus is 0.</p></li>
                     <li><p><code>auditTrailVerificationCheck</code>: 0/1. FaceTec will determine whether the Audit Trail Image came from the same session as the FaceMap or not. 0 = same session, 1 = not same session.</p></li>
                     <li><p><code>isLowQuality</code>: true/false. Facetec evaluates session data for face pose, lighting, and many other indicators to assess the quality of the overall capture, this boolean indicates whether Facetec evaluated the image(s) to be of poor quality. true = Evaluated as low quality. false = Not evaluated as low quality.</p></li>
                     <li><p><code>isReplayFaceMap</code>: true/false. Indication of whether a FaceMap was seen by the system already and thus is a replay. true = the FaceMap was a replay. false = the FaceMap was not a replay. </p></li>
                     <li><p><code>auditTrailMatchCheck</code>: 0/1. FaceTec Custom Server runs a match of the Audit Trail Image to the Session to help determine if that the person in the Audit Trail Image matches the person from the FaceMap. 0 = The Audit Trail Image matches the FaceMap. 1 = The Audit Trail Image does not match the FaceMap.</p></li>

                  </ul>

                  <p><strong>Sample Response:</strong></p>
                  <div className="code-container">
                      <CodeBlocks success={COMPARE_RESPONSE_SUCCESS_JSON()} failure={COMPARE_RESPONSE_FAILURE_JSON()} />
                  </div>
                  <p></p>
              </section>

              <section>
                <h3 id="face-search">Face Search</h3>
                <p className="section-endpoint"><code>POST /search</code></p>

                  <p>Perform a search against all of the enrollments which will return the top 10 best matches.</p>

                  <p><strong>Required Parameters:</strong></p>
                  <ul>
                      <li><p><code>enrollmentIdentifier</code> <strong>or</strong> <code>faceMap</code></p></li>
                      <li><p><code>auditTrailImage</code>: Captured image from the Session and provided back to the developer for security and auditing purposes.</p></li>
                      <li><p><code>lowQualityAuditTrailImage</code>: Captured low quality image from the Session and provided back to the developer for security and auditing purposes.</p></li>
                  </ul>

                  <p><strong>Sample Request:</strong></p>
                  <div className="code-container">
                      <CodeBlocks curl={SEARCH_CURL({appToken})} node={SEARCH_NODEJS({appToken})} />
                  </div>

                  <p><strong>Response Data:</strong></p>
                  <ul>
                    <li><p><code>matchLevel</code>: Facetec is capable of matching at FAR ranges of up to 1 in 4,200,000. Please see <Link to="/matching-guide">Matching Guide</Link> for more information on interpreting FaceTec Match Levels.</p></li>
                    <li><p><code>glasses</code>: true/false. User of the captured session to be wearing glasses or not. true = User of the captured session was evaluated to be wearing glasses. false = User of the captured session was evaluated to not be wearing glasses.</p></li>
                    <li><p><code>sessionTokenStatus</code>: 0/1/2/3/4. 0 = Not Applicable, 1 = Valid, 2 = Expired, 3 = Not Provided, 4 = Invalid.</p></li>
                    <li><p><code>faceMapType</code>: 0/1/2. 0 = 3D FaceMap, 1 = 2D FaceMap, 2 = Unknown.</p></li>
                    <li><p><code>livenessStatus</code>: 0/1/2. 0 = passed, 1 = undetermined, 2 = undetermined. The FaceTec 3D FaceMap came from a session where there was a live human being if and only if the livenessStatus is 0.</p></li>
                    <li><p><code>auditTrailVerificationCheck</code>: 0/1. FaceTec will determine whether the Audit Trail Image came from the same session as the FaceMap or not. 0 = same session, 1 = not same session.</p></li>
                    <li><p><code>isLowQuality</code>: true/false. Facetec evaluates session data for face pose, lighting, and many other indicators to assess the quality of the overall capture, this boolean indicates whether Facetec evaluated the image(s) to be of poor quality. true = Evaluated as low quality. false = Not evaluated as low quality.</p></li>
                    <li><p><code>isReplayFaceMap</code>: true/false. Indication of whether a FaceMap was seen by the system already and thus is a replay. true = the FaceMap was a replay. false = the FaceMap was not a replay. </p></li>
                    <li><p><code>auditTrailMatchCheck</code>: 0/1. FaceTec Custom Server runs a match of the Audit Trail Image to the Session to help determine if that the person in the Audit Trail Image matches the person from the FaceMap. 0 = The Audit Trail Image matches the FaceMap. 1 = The Audit Trail Image does not match the FaceMap.</p></li>
                    <li><p><code>results</code>: Details about matched search results.</p></li>
                    <li><p><code>enrollmentIdentifier</code>: Stored enrollmentIdentifier value.</p></li>
                    <li><p><code>auditTrailImage</code>: Stored auditTrailImage for returned enrollmentIdentifier.</p></li>
                  </ul>

                  <p><strong>Sample Response:</strong></p>
                  <div className="code-container">
                    <CodeBlocks success={SEARCH_RESPONSE_SUCCESS_JSON()} failure={SEARCH_RESPONSE_FAILURE_JSON()} />
                  </div>
                  <p></p>
              </section>

              <section>
                <h3 id="id-check">ID Check</h3>
                <p className="section-endpoint"><code>POST /id-check</code></p>

                  <p><strong>Description:</strong></p>
                  <p>Match FaceMap data with captured Identity Document image. Liveness was already ran on the previously created Enrollment.</p>

                  <p><strong>Required Parameters:</strong></p>
                  <ul>
                      <li><p><code>enrollmentIdentifier</code> <strong>or</strong> <code>faceMap</code></p></li>
                      <li><p><code>idScan</code>: The Facetec ID Scan.</p></li>
                      <li><p><code>idScanFrontImage</code>: Captured image of the front of the ID from the Facetec ID Scan and provided back to the developer.</p></li>
                      <li><p><code>idScanBackImage</code>: Captured image of the back of the ID from the Facetec ID Scan and provided back to the developer.</p></li>
                  </ul>

                  <p><strong>Sample Request:</strong></p>
                  <div className="code-container">
                      <CodeBlocks curl={ID_CHECK_CURL({appToken})} node={ID_CHECK_NODEJS({appToken})} />
                  </div>

                  <p><strong>Response Data:</strong></p>
                  <ul>
                    <li><p><code>glasses</code>: true/false. User of the captured session to be wearing glasses or not. true = User of the captured session was evaluated to be wearing glasses. false = User of the captured session was evaluated to not be wearing glasses.</p></li>
                    <li><p><code>sessionTokenStatus</code>: 0/1/2/3/4. 0 = Not Applicable, 1 = Valid, 2 = Expired, 3 = Not Provided, 4 = Invalid.</p></li>
                    <li><p><code>faceMapType</code>: 0/1/2. 0 = 3D FaceMap, 1 = 2D FaceMap, 2 = Unknown.</p></li>
                    <li><p><code>ageEstimateGroup</code>: 0/1/2/3/4/5. The estimated age group of the FaceMap. 0 = Age Under 13, 1 = Age Over 13, 2 = Age Over 18, 3 = Age Over 25, 4 = Age Over 30, 5 = Age Over 22.</p></li>
                    <li><p><code>matchLevel</code>: Facetec is capable of matching at FAR ranges of up to 1 in 4,200,000. Please see <Link to="/matching-guide">Matching Guide</Link> for more information on interpreting FaceTec Match Levels.</p></li>
                    <li><p><code>livenessStatus</code>: 0/1/2. 0 = passed, 1 = undetermined, 2 = undetermined. The FaceTec 3D FaceMap came from a session where there was a live human being if and only if the livenessStatus is 0.</p></li>
                    <li><p><code>idScanAgeEstimateGroup</code>:  0/1/2/3/4/5. The estimated age group of the face on the Identity Document. 0 = Age Under 13, 1 = Age Over 13, 2 = Age Over 18, 3 = Age Over 25, 4 = Age Over 30, 5 = Age Over 22.</p></li>
                    <li><p><code>auditTrailVerificationCheck</code>: 0/1. FaceTec will determine whether the Audit Trail Image came from the same session as the FaceMap or not. 0 = same session, 1 = not same session.</p></li>
                    <li><p><code>isLowQuality</code>: true/false. Facetec evaluates session data for face pose, lighting, and many other indicators to assess the quality of the overall capture, this boolean indicates whether Facetec evaluated the image(s) to be of poor quality. true = Evaluated as low quality. false = Not evaluated as low quality.</p></li>
                    <li><p><code>auditTrailMatchCheck</code>: 0/1. FaceTec Custom Server runs a match of the Audit Trail Image to the Session to help determine if that the person in the Audit Trail Image matches the person from the FaceMap. 0 = The Audit Trail Image matches the FaceMap. 1 = The Audit Trail Image does not match the FaceMap.</p></li>
                    <li><p><code>isReplayFaceMap</code>: true/false. Indication of whether a FaceMap was seen by the system already and thus is a replay. true = the FaceMap was a replay. false = the FaceMap was not a replay. </p></li>
                  </ul>

                  <p><strong>Sample Response:</strong></p>
                  <div className="code-container">
                    <CodeBlocks success={ID_CHECK_RESPONSE_SUCCESS_JSON()} failure={ID_CHECK_RESPONSE_FAILURE_JSON()} />
                  </div>
                  <p></p>
              </section>


              <section>
                <h3 id="age-check">Age Check</h3>
                <p className="section-endpoint"><code>POST /age-check</code></p>

                  <p>Check a FaceMap or image against a specified age group with high confidence.</p>

                  <p><strong>Required Parameters:</strong></p>
                  <ul>
                      <li><p><code>enrollmentIdentifier</code> <strong>or</strong> <code>faceMap</code> <strong>or</strong> <code>image</code></p></li>
                      <li><p><code>targetAge</code>: 0/1/2/3/4. The target age group to check against. 0 = Age 13 or over, 1 = Age 16 or over, 2 = Age 18 or over, 3 = Age 21 or over, 4 = Age 25 or over.</p></li>
                      <li><p><code>auditTrailImage</code>: Captured image from the Session and provided back to the developer for security and auditing purposes.</p></li>
                      <li><p><code>lowQualityAuditTrailImage</code>: Captured low quality image from the Session and provided back to the developer for security and auditing purposes.</p></li>
                  </ul>

                  <p><strong>Sample Request:</strong></p>
                  <div className="code-container">
                      <CodeBlocks curl={AGE_CHECK_CURL({appToken})} node={AGE_CHECK_NODEJS({appToken})} />
                  </div>

                  <p><strong>Response Data:</strong></p>
                  <ul>
                    <li><p><code>glasses</code>: true/false. User of the captured session to be wearing glasses or not. true = User of the captured session was evaluated to be wearing glasses. false = User of the captured session was evaluated to not be wearing glasses.</p></li>
                    <li><p><code>sessionTokenStatus</code>: 0/1/2/3/4. 0 = Not Applicable, 1 = Valid, 2 = Expired, 3 = Not Provided, 4 = Invalid.</p></li>
                    <li><p><code>faceMapType</code>: 0/1/2. 0 = 3D FaceMap, 1 = 2D FaceMap, 2 = Unknown.</p></li>
                    <li><p><code>livenessStatus</code>: 0/1/2. 0 = passed, 1 = undetermined, 2 = undetermined. The FaceTec 3D FaceMap came from a session where there was a live human being if and only if the livenessStatus is 0.</p></li>
                    <li><p><code>auditTrailVerificationCheck</code>: 0/1. FaceTec will determine whether the Audit Trail Image came from the same session as the FaceMap or not. 0 = same session, 1 = not same session.</p></li>
                    <li><p><code>isLowQuality</code>: true/false. Facetec evaluates session data for face pose, lighting, and many other indicators to assess the quality of the overall capture, this boolean indicates whether Facetec evaluated the image(s) to be of poor quality. true = Evaluated as low quality. false = Not evaluated as low quality.</p></li>
                    <li><p><code>ageCheckResult</code>: 0/1. A return value indicating that there is high confidence that the FaceMap belong to the target age group provided. However, a return value of "1" only indicates that there was not enough confidence to say that the FaceMap belongs to the target age group.  A "1" return value should not be used as confidence that the FaceMap is not in the target age group. 0 = High Confidence, 1 = Undetermined</p></li>
                    <li><p><code>auditTrailMatchCheck</code>: 0/1. FaceTec Custom Server runs a match of the Audit Trail Image to the Session to help determine if that the person in the Audit Trail Image matches the person from the FaceMap. 0 = The Audit Trail Image matches the FaceMap. 1 = The Audit Trail Image does not match the FaceMap.</p></li>
                    <li><p><code>isReplayFaceMap</code>: true/false. Indication of whether a FaceMap was seen by the system already and thus is a replay. true = the FaceMap was a replay. false = the FaceMap was not a replay. </p></li>
                  </ul>

                  <p><strong>Sample Response:</strong></p>
                  <div className="code-container">
                    <CodeBlocks success={AGE_CHECK_RESPONSE_SUCCESS_JSON()} failure={AGE_CHECK_RESPONSE_FAILURE_JSON()} />
                  </div>
                  <p></p>
              </section>


              <section>
                <h3 id="estimate-age">Estimate Age</h3>
                <p className="section-endpoint"><code>POST /estimate-age</code></p>

                  <p>Get the estimated age group of enrollmentIdentifier or faceMap or image.</p>

                  <p><strong>Required Parameters:</strong></p>
                  <ul>
                      <li><p><code>enrollmentIdentifier</code> <strong>or</strong> <code>faceMap</code> <strong>or</strong> <code>image</code></p></li>
                      <li><p><code>auditTrailImage</code>: Captured image from the Session and provided back to the developer for security and auditing purposes.</p></li>
                      <li><p><code>lowQualityAuditTrailImage</code>: Captured low quality image from the Session and provided back to the developer for security and auditing purposes.</p></li>
                  </ul>

                  <p><strong>Sample Request:</strong></p>
                  <div className="code-container">
                      <CodeBlocks curl={ESTIMATE_AGE_CURL({appToken})} node={ESTIMATE_AGE_NODEJS({appToken})} />
                  </div>

                  <p><strong>Response Data:</strong></p>
                  <ul>
                    <li><p><code>glasses</code>: true/false. User of the captured session to be wearing glasses or not. true = User of the captured session was evaluated to be wearing glasses. false = User of the captured session was evaluated to not be wearing glasses.</p></li>
                    <li><p><code>sessionTokenStatus</code>: 0/1/2/3/4. 0 = Not Applicable, 1 = Valid, 2 = Expired, 3 = Not Provided, 4 = Invalid.</p></li>
                    <li><p><code>faceMapType</code>: 0/1/2. 0 = 3D FaceMap, 1 = 2D FaceMap, 2 = Unknown.</p></li>
                    <li><p><code>ageEstimateGroup</code>: 0/1/2/3/4/5. The estimated age group of enrollmentIdentifier or faceMap or image data. 0 = Age Under 13, 1 = Age Over 13, 2 = Age Over 18, 3 = Age Over 25, 4 = Age Over 30, 5 = Age Over 22.</p></li>
                    <li><p><code>livenessStatus</code>: 0/1/2. 0 = passed, 1 = undetermined, 2 = undetermined. The FaceTec 3D FaceMap came from a session where there was a live human being if and only if the livenessStatus is 0.</p></li>
                    <li><p><code>auditTrailVerificationCheck</code>: 0/1. FaceTec will determine whether the Audit Trail Image came from the same session as the FaceMap or not. 0 = same session, 1 = not same session.</p></li>
                    <li><p><code>isLowQuality</code>: true/false. Facetec evaluates session data for face pose, lighting, and many other indicators to assess the quality of the overall capture, this boolean indicates whether Facetec evaluated the image(s) to be of poor quality. true = Evaluated as low quality. false = Not evaluated as low quality.</p></li>
                    <li><p><code>auditTrailMatchCheck</code>: 0/1. FaceTec Custom Server runs a match of the Audit Trail Image to the Session to help determine if that the person in the Audit Trail Image matches the person from the FaceMap. 0 = The Audit Trail Image matches the FaceMap. 1 = The Audit Trail Image does not match the FaceMap.</p></li>
                    <li><p><code>isReplayFaceMap</code>: true/false. Indication of whether a FaceMap was seen by the system already and thus is a replay. true = the FaceMap was a replay. false = the FaceMap was not a replay. </p></li>
                  </ul>

                  <p><strong>Sample Response:</strong></p>
                  <div className="code-container">
                    <CodeBlocks success={ESTIMATE_AGE_RESPONSE_SUCCESS_JSON()} failure={ESTIMATE_AGE_RESPONSE_FAILURE_JSON()} />
                  </div>
                  <p></p>
              </section>


              <section>
                  <h3 id="creating-2d-single-image-faceMaps">Creating 2D Single Image FaceMaps</h3>
                  <p>Create FaceMap from 2D image. This API internally calls the FaceTec Server SDK&apos;s createFaceMapFromImage API.  With the retrieved 2D Single Image FaceMap, you can call the /match-2d-2d to match against another 2D image, or /match-3d-2d to match against a FaceTec 3D FaceMap.</p>

                  <p className="section-endpoint"><code>POST /create-facemap-from-single-image</code></p>
                  <p><strong>Required Parameters:</strong></p>
                  <ul>
                      <li><p><code>image</code></p></li>
                  </ul>

                  <p><strong>Sample Request:</strong></p>
                  <div className="code-container">
                      <CodeBlocks curl={FACEMAP_POST_CURL({appToken})} node={FACEMAP_POST_NODEJS({appToken})} />
                  </div>
                  <p><strong>Response Data:</strong></p>
                  <ul>
                    <li><p><code>glasses</code>: true/false. User of the captured session to be wearing glasses or not. true = User of the captured session was evaluated to be wearing glasses. false = User of the captured session was evaluated to not be wearing glasses.</p></li>
                    <li><p><code>creationStatus</code>: 0/1/2/3. The status of creation attempt of a 2D Single Image FaceMap from a 2D Image. 0 = 2D Single Image FaceMap was created, 1 = Invalid Image, 2 = Detection Issue, 3 = Too Low Quality.</p></li>
                    <li><p><code>faceMap</code>: Generated FaceMap value.</p></li>
                    <li><p><code>faceMapType</code>: 0/1/2. 0 = 3D FaceMap, 1 = 2D FaceMap, 2 = Unknown.</p></li>
                    <li><p><code>isLowQuality</code>: true/false. Facetec evaluates session data for face pose, lighting, and many other indicators to assess the quality of the overall capture, this boolean indicates whether Facetec evaluated the image(s) to be of poor quality. true = Evaluated as low quality. false = Not evaluated as low quality.</p></li>
                  </ul>

                  <p><strong>Sample Response:</strong></p>
                  <div className="code-container">
                      <CodeBlocks success={FACEMAP_POST_RESPONSE_SUCCESS_JSON()} failure={FACEMAP_POST_RESPONSE_FAILURE_JSON()} />
                  </div>
                  <p></p>
              </section>


              <SDKSidebar menuType="main" title="REST API"/>

            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/zoom-server-rest-api.jsx